import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Check } from 'lucide-react';
const bonuses = ['Lista de Compras Fitness para 30 Días', 'Meal Prep Express para Toda la Semana', '15 Desayunos Altos en Proteína', '20 Snacks Fitness Bajos en Calorías', 'Guía de Salsas Proteicas Caseras', 'Postres Fitness Sin Azúcar', 'Air Fryer Fitness Recipes', 'Guía de Supermercado Fitness Económico', 'Menú Semanal para Pérdida de Grasa', 'Tabla de Macros y Porciones Inteligentes', '10 Cenas Proteicas por Menos de $5', 'Batch Cooking para Personas Sin Tiempo', 'Recetas Fitness con Solo 5 Ingredientes', 'Guía de Proteínas: Qué Comprar y Cuál Elegir', 'Plan Detox de Comidas Altas en Proteína', '7 Almuerzos Fitness para Llevar al Trabajo', 'Cheat Meals Fitness y Saludables', 'Guía de Sustituciones Saludables', 'Calendario de Comidas Fitness de 30 Días', 'Pack de Smoothies Altos en Proteína'];
export function WhatsIncluded() {
  return <section className="py-24 md:py-28 bg-lightGreen" data-id="element-219">
      <div className="container mx-auto px-4" data-id="element-220">
        <div className="text-center mb-16 md:mb-20" data-id="element-221">
          <h2 className="text-3xl md:text-4xl font-black text-darkGreen mb-6 font-montserrat uppercase" data-id="element-222">
            ¿Qué incluye el{' '}
            <span className="text-vibrantGreen" data-id="element-223">Pack Completo</span>?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-224">
            Todo lo que necesitas para transformar tus cenas y alcanzar tus
            objetivos físicos sin complicarte la vida.
          </p>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-225">
          {/* Main Product Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl shadow-xl p-8 md:p-10 mb-12 border-2 border-vibrantGreen/20 relative overflow-hidden" data-id="element-226">
            <div className="absolute top-0 right-0 bg-vibrantGreen text-darkGreen font-bold py-1 px-4 rounded-bl-xl text-sm uppercase tracking-wider" data-id="element-227">
              Producto Principal
            </div>
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-228">
              <div className="w-24 h-24 bg-lightGreen rounded-2xl flex items-center justify-center flex-shrink-0" data-id="element-229">
                <BookOpen className="w-12 h-12 text-vibrantGreen" data-id="element-230" />
              </div>
              <div data-id="element-231">
                <h3 className="text-2xl md:text-3xl font-bold text-darkGreen mb-3 font-montserrat" data-id="element-232">
                  📖 Ebook: 30 Cenas Proteicas en 15 Minutos
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-233">
                  El manual definitivo con{' '}
                  <strong className="text-darkGreen font-bold" data-id="element-234">
                    recetas paso a paso
                  </strong>
                  , fotos reales,
                  <strong className="text-darkGreen font-bold" data-id="element-235">
                    {' '}
                    macros calculados
                  </strong>{' '}
                  y porciones exactas para que no tengas que pensar qué cocinar
                  cada noche.{' '}
                  <em className="text-vibrantGreen font-medium" data-id="element-236">
                    ¡Rápido y fácil!
                  </em>
                </p>
              </div>
            </div>
          </motion.div>

          {/* Bonuses Grid */}
          <div className="mb-8 flex items-center gap-3 justify-center" data-id="element-237">
            <Gift className="w-8 h-8 text-urgencyRed" data-id="element-238" />
            <h3 className="text-2xl font-bold text-darkGreen font-montserrat uppercase" data-id="element-239">
              + 20 Bonos Exclusivos de Regalo
            </h3>
            <Gift className="w-8 h-8 text-urgencyRed" data-id="element-240" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-241">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-start gap-3 hover:shadow-md hover:border-vibrantGreen/30 transition-all group" data-id="element-242">
                <div className="bg-lightGreen p-1.5 rounded-full group-hover:bg-vibrantGreen transition-colors mt-0.5" data-id="element-243">
                  <Check className="w-4 h-4 text-vibrantGreen group-hover:text-white" data-id="element-244" />
                </div>
                <span className="font-medium text-gray-700 group-hover:text-darkGreen transition-colors text-sm md:text-base" data-id="element-245">
                  {bonus}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}